import { render, staticRenderFns } from "./Strategies.vue?vue&type=template&id=4a1b3a5c&scoped=true&"
import script from "./Strategies.vue?vue&type=script&lang=js&"
export * from "./Strategies.vue?vue&type=script&lang=js&"
import style0 from "./Strategies.vue?vue&type=style&index=0&id=4a1b3a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1b3a5c",
  null
  
)

export default component.exports